export default __webpack_public_path__ + "static/caution-warning-en-4f5ed875997ccaf1e47ea7e0fa5ab658.webp";